<template>
  <div class="ss-root" :style="themePageStyle">
  <head>
    <meta charset="utf-8" /><title>FLOCKR | Saved Searches</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <link rel="shortcut icon" href="/assets/images/favicon.svg">
    <link href="/assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link href="/assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link href="/assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="/assets/css/custom.css" rel="stylesheet" type="text/css" />
  </head>
  <body data-sidebar="dark">
  <div id="layout-wrapper">
    <nav class="ss-topbar">
      <div class="container d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center" style="gap:16px;">
          <back-button class="me-2" />
          <a href="javascript:void(0)" @click="$router.push('/')"><img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" /></a>
          <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:15px;"><i class="mdi mdi-magnify me-1"></i>Saved Searches</span>
        </div>
        <a href="javascript:void(0)" @click="$router.push('/marketplace/saved')" style="color:#BFA164;font-size:13px;text-decoration:none;"><i class="mdi mdi-heart me-1"></i>Saved Listings</a>
      </div>
    </nav>

    <div class="container ss-container">
      <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>
      <div v-else-if="searches.length === 0" class="text-center py-5">
        <i class="mdi mdi-magnify-remove-outline" style="font-size:64px;color:var(--fm-s,#3A3530);"></i>
        <h5 class="mt-3" style="color:var(--fm-h,#F5F0E8);">No Saved Searches</h5>
        <p style="color:var(--fm-s,#6B6356);">Save a search from the search results page to get notified of new matches.</p>
        <button class="btn btn-warning mt-2" @click="$router.push('/marketplace/search')"><i class="mdi mdi-magnify me-1"></i> Search Listings</button>
      </div>
      <div v-else>
        <div v-for="(s, si) in searches" :key="'s-'+si" class="ss-card">
          <div class="d-flex align-items-center gap-3">
            <div class="ss-icon"><i class="mdi mdi-magnify" style="font-size:20px;color:#BFA164;"></i></div>
            <div class="flex-fill">
              <div class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:14px;">{{ s.search_name || 'Unnamed Search' }}</div>
              <div style="color:var(--fm-s,#6B6356);font-size:12px;">Saved {{ formatDate(s.created_at) }}</div>
              <div class="d-flex flex-wrap gap-1 mt-1">
                <span v-for="(v, k) in parseFilters(s.search_filters)" :key="k" class="badge bg-dark" style="font-size:10px;border:1px solid var(--fm-br,#2A2520);">{{ k }}: {{ v }}</span>
              </div>
            </div>
            <div class="d-flex gap-2">
              <button class="btn btn-sm btn-warning" @click="runSearch(s)"><i class="mdi mdi-magnify"></i></button>
              <button class="btn btn-sm btn-outline-danger" @click="deleteSearch(s.id, si)"><i class="mdi mdi-delete"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </body>
  </div>
</template>
<style>

/* === GLOBAL THEME === */
html[data-theme="light"] body { background:#FFFFFF!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-card,html[data-theme="light"] .p2c,html[data-theme="light"] .ld-section,html[data-theme="light"] .ld-action-card,html[data-theme="light"] .ld-seller-card,html[data-theme="light"] .ld-info-card,html[data-theme="light"] .ld-related-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-overlay .fm-modal,html[data-theme="light"] .ad-overlay .ad-modal { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-input,html[data-theme="light"] .fm-select { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-label { color:#555!important; }
html[data-theme="dark"] body { background:#0A0A0A!important; color:#F5F0E8!important; }
</style>
<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .card-body{color:#1A1A1A!important}
html[data-theme="light"] .modal-content{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .form-control,html[data-theme="light"] .form-select{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .table{color:#1A1A1A!important}
html[data-theme="light"] .table th{color:#555!important;border-color:#E8E2DA!important}
html[data-theme="light"] .table td{border-color:#F0EBE4!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] [style*="background:#0F0F0F"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#141414"]{background:#FFFFFF!important}
html[data-theme="light"] [style*="background:#1E1E1E"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0A0A0A"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#1a1510"]{background:#FFF8F0!important}
html[data-theme="light"] [style*="background:#1A1A1A"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="border:1px solid #1E1E1E"]{border-color:#E8E2DA!important}
html[data-theme="light"] [style*="border:1px solid #2A2520"]{border-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1A1A1A"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1E1E1E"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #2A2520"]{border-bottom-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-top:1px solid #2A2520"]{border-top-color:#E0D8D0!important}
html[data-theme="light"] [style*="color:#BFA164"]{color:#BFA164!important}
html[data-theme="light"] [style*="color:#50C878"]{color:#50C878!important}
html[data-theme="light"] [style*="color:#4FC3F7"]{color:#4FC3F7!important}
html[data-theme="light"] [style*="color:#FF6B6B"]{color:#FF6B6B!important}
html[data-theme="light"] [style*="color:#FF9800"]{color:#FF9800!important}
html[data-theme="light"] [style*="color:#CE93D8"]{color:#CE93D8!important}
</style>
<style scoped>
.ss-root{background:var(--fm-bg2,#0F0F0F)!important;min-height:100vh}
.ss-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:rgba(10,10,10,.95)!important;backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.ss-container{padding-top:80px;padding-bottom:60px;max-width:800px}
.ss-card{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:16px;margin-bottom:12px}
.ss-icon{width:40px;height:40px;border-radius:50%;background:rgba(191,161,100,.08)!important;display:flex;align-items:center;justify-content:center;flex-shrink:0}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  .ss-container { padding-top: 70px !important; padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px)) !important; padding-left: 12px !important; padding-right: 12px !important; }
  .ss-card { padding: 12px !important; border-radius: 10px !important; }
  .ss-icon { width: 36px; height: 36px; }
}
</style>
<script>
import { executeJson, flocker } from "@/api";
export default {
  name: "SavedSearchesPage",
  data(){return{
      darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
loading:true,searches:[]}},
  mounted(){
    // Apply global theme
    var t=localStorage.getItem('flockr_theme')||'dark';window.__flockrSetTheme(t);
var u=sessionStorage.getItem('userId');if(!u){this.$router.push('/login');return}this.fetch()},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    themeCardStyle(){return this.darkMode?'background:#141414!important;border:1px solid #1E1E1E!important;':'background:#FFFFFF!important;border:1px solid #E8E2DA!important;'},
    themeInputStyle(){return this.darkMode?'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;':'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;'},
  },
  methods:{
    async fetch(){this.loading=true;try{var r=await executeJson({function:"getMySavedSearches",userId:sessionStorage.getItem('userId')},flocker);if(r.data.success)this.searches=r.data.data.searches||[]}catch(e){console.error(e)}this.loading=false},
    async deleteSearch(id,idx){if(!confirm('Delete this saved search?'))return;try{var r=await executeJson({function:"deleteSavedSearch",searchId:id},flocker);if(r.data.success)this.searches.splice(idx,1)}catch(e){console.error(e)}},
    runSearch(s){try{var filters=JSON.parse(s.search_filters);this.$router.push({path:'/marketplace/search',query:filters})}catch(e){this.$router.push('/marketplace/search')}},
    parseFilters(f){try{return JSON.parse(f)}catch(e){return{}}},
    formatDate(d){if(!d)return'';return new Date(d).toLocaleDateString('en-KE',{day:'numeric',month:'short',year:'numeric'})}
  }
};
</script>
